<template>
  <div class="productList">
    <ul class="productList">
      <li class="productList__item"
      v-for="(item, index) in list"
      :key="index">
        <a href="#" class="productList__a"
        @click='go_page(`/front/onlinestore/${category.english}/${item.id}`)'>
          <div class="productList__img">
            <img :src="item.images.main" class="img">
            <img src="@/assets/icon/new_tag.png" class="isNew" v-if="item.is_new">
          </div>
          <div class="productList__main">
            <div class="productList__header">
              <p class="productList__title">{{item.title}}</p>
              <p class="productList__id">{{item.id}}</p>
            </div>
            <p class="productList__price">NT${{item.price}}</p>
          </div>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ['list', 'category'],
  methods: {
    go_page(route) {
      this.$router.push(route);
    },
  },
};
</script>
